import { render, staticRenderFns } from "./ListaEspecialistasReplica.vue?vue&type=template&id=1a4c46bb"
import script from "./ListaEspecialistasReplica.vue?vue&type=script&lang=js"
export * from "./ListaEspecialistasReplica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports